<template>

    <div class="widget-content-logo" v-background-image="logoUrl"></div>

</template>

<script>

import { Vue, Options } from 'vue-class-component'

export default Options({
    name: 'dmb-widget-content-logo',
    props: {
        widget: Object,
        freeze: Boolean
    }
})(
    class WidgetContentLogo extends Vue
    {
        get logoUrl(){

            return this.$store.state.assets.logoUrl
        }
    }
)

</script>
<style src="../../../scss/component/widget/WidgetContentLogo.scss" lang="scss"></style>